import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { MdEdit, MdSave, MdRefresh, MdPlayArrow } from "react-icons/md";
import LuckyWheel from "../../components/LuckyWheel";

const AdminWheel = () => {
  const [slots, setSlots] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch Slots
      try {
        const slotRes = await api.get("/wheel/slots");
        setSlots(slotRes.data.sort((a, b) => a.index - b.index));
      } catch (err) {
        console.error("Error fetching wheel slots:", err);
        toast.error("Không thể tải cấu hình 10 ô vòng quay");
      }

      // Fetch Vouchers
      try {
        const vRes = await api.get("/vouchers");
        const availableVouchers = vRes.data || [];
        setVouchers(availableVouchers.filter(v => v.usageType === "luckywheel" || v.isSpinPrize));
      } catch (err) {
        console.error("Error fetching vouchers for wheel:", err);
        toast.error("Không thể tải danh sách Voucher");
      }
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (slot) => {
    setEditingId(slot._id);
    setEditData({ ...slot });
  };

  const saveEdit = async (id) => {
    try {
      await api.put(`/admin/wheel/slots/${id}`, editData);
      toast.success("Cập nhật ô quay thành công!");
      setEditingId(null);
      fetchData();
    } catch (err) {
      toast.error("Lỗi khi lưu cấu hình");
    }
  };

  const totalProbability = slots.reduce((sum, s) => sum + s.probability, 0);

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-black text-gray-900">Quản lý Vòng quay</h1>
          <p className="text-gray-500 mt-1">Cấu hình 10 ô giải thưởng và tỉ lệ trúng</p>
        </div>
        <div className="flex gap-2">
          <button 
            onClick={() => setIsPreviewOpen(true)}
            className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-red-600 text-white rounded-xl font-bold hover:scale-105 active:scale-95 transition-all shadow-lg shadow-orange-200"
          >
            <MdPlayArrow size={24} />
            Test Quay
          </button>
          <button 
            onClick={fetchData}
            className="p-2 bg-white border rounded-xl hover:bg-gray-50 transition-all shadow-sm"
          >
            <MdRefresh size={24} className="text-gray-600" />
          </button>
        </div>
      </div>

      <div className={`mb-6 p-4 rounded-2xl flex items-center gap-3 font-bold ${
        Math.abs(totalProbability - 1) < 0.001 
          ? "bg-green-50 text-green-600 border border-green-100" 
          : "bg-red-50 text-red-600 border border-red-100"
      }`}>
        <span className="text-xl">📊</span>
        <span>Tổng tỉ lệ hiện tại: {(totalProbability * 100).toFixed(1)}%</span>
        {Math.abs(totalProbability - 1) > 0.001 && (
          <span className="text-xs font-medium ml-auto">(Gợi ý: Tổng tỉ lệ nên bằng 100% để chính xác nhất)</span>
        )}
      </div>

      <div className="bg-white rounded-[24px] shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100">
                <th className="px-6 py-4 font-black text-gray-600 uppercase text-xs tracking-wider">Vị trí</th>
                <th className="px-6 py-4 font-black text-gray-600 uppercase text-xs tracking-wider">Hiển thị (Nhãn)</th>
                <th className="px-6 py-4 font-black text-gray-600 uppercase text-xs tracking-wider">Màu sắc</th>
                <th className="px-6 py-4 font-black text-gray-600 uppercase text-xs tracking-wider">Tỉ lệ (%)</th>
                <th className="px-6 py-4 font-black text-gray-600 uppercase text-xs tracking-wider">Voucher liên kết</th>
                <th className="px-6 py-4 font-black text-gray-600 uppercase text-xs tracking-wider text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {slots.map((slot) => (
                <tr key={slot._id} className="hover:bg-gray-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <span className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center font-black text-gray-500 text-sm">
                      {slot.index + 1}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    {editingId === slot._id ? (
                      <input 
                        type="text" 
                        value={editData.label}
                        onChange={(e) => setEditData({...editData, label: e.target.value})}
                        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none font-bold"
                      />
                    ) : (
                      <span className="font-bold text-gray-800 uppercase">{slot.label}</span>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {editingId === slot._id ? (
                      <div className="flex items-center gap-2">
                        <input 
                          type="color" 
                          value={editData.color}
                          onChange={(e) => setEditData({...editData, color: e.target.value})}
                          className="w-10 h-10 border-0 p-0 rounded-lg cursor-pointer overflow-hidden"
                        />
                        <input 
                          type="text" 
                          value={editData.color}
                          onChange={(e) => setEditData({...editData, color: e.target.value})}
                          className="w-24 px-2 py-2 border rounded-lg text-xs font-mono"
                        />
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-md shadow-inner border border-gray-200" style={{ backgroundColor: slot.color }}></div>
                        <span className="text-xs font-mono text-gray-400">{slot.color}</span>
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {editingId === slot._id ? (
                      <div className="flex items-center gap-2">
                        <input 
                          type="number" 
                          step="0.1"
                          min="0"
                          max="100"
                          value={editData.probability * 100}
                          onChange={(e) => setEditData({...editData, probability: parseFloat(e.target.value) / 100})}
                          className="w-20 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none font-bold text-blue-600"
                        />
                        <span className="text-gray-400 text-xs">(1 - 100%)</span>
                      </div>
                    ) : (
                      <div className="flex flex-col">
                        <span className="font-black text-blue-600">{(slot.probability * 100).toFixed(1)}%</span>
                        <div className="w-24 h-1.5 bg-gray-100 rounded-full mt-1 overflow-hidden">
                          <div className="h-full bg-blue-500" style={{ width: `${slot.probability * 100}%` }}></div>
                        </div>
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {editingId === slot._id ? (
                      <select 
                        value={editData.voucherId || ""}
                        onChange={(e) => setEditData({...editData, voucherId: e.target.value || null})}
                        className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none font-medium"
                      >
                        <option value="">❌ Không gán Voucher (Chỉ hiện nhãn)</option>
                        {vouchers.map(v => (
                          <option key={v._id} value={v._id}>
                             {v.type === "gift" ? `[QUÀ TẶNG] ${v.giftName}` : `[${v.code}] ${v.description}`}
                          </option>
                        ))}
                      </select>
                    ) : (
                      slot.voucherId ? (
                        <div className="inline-flex items-center gap-2 px-3 py-1 bg-red-50 text-red-600 rounded-full text-xs font-black">
                          <span className="w-1.5 h-1.5 bg-red-600 rounded-full animate-pulse"></span>
                          {(() => {
                            const v = vouchers.find(v => v._id === slot.voucherId);
                            if (!v) return "Đang tải...";
                            return v.type === "gift" ? v.giftName : v.code;
                          })()}
                        </div>
                      ) : (
                        <span className="text-gray-400 text-xs italic">Không có Voucher</span>
                      )
                    )}
                  </td>
                  <td className="px-6 py-4 text-right">
                    {editingId === slot._id ? (
                      <div className="flex justify-end gap-2">
                        <button 
                          onClick={() => setEditingId(null)}
                          className="px-3 py-2 text-gray-500 hover:bg-gray-100 rounded-lg text-sm font-bold"
                        >
                          Hủy
                        </button>
                        <button 
                          onClick={() => saveEdit(slot._id)}
                          className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-bold hover:bg-blue-700 shadow-lg shadow-blue-200"
                        >
                          <MdSave size={18} />
                          Lưu
                        </button>
                      </div>
                    ) : (
                      <button 
                        onClick={() => startEdit(slot)}
                        className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
                      >
                        <MdEdit size={20} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {loading && (
             <div className="py-20 text-center">
                <div className="inline-block w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
             </div>
          )}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-blue-50/50 border border-blue-100 p-6 rounded-[24px]">
          <h3 className="font-black text-blue-900 mb-2 flex items-center gap-2">
            💡 Mẹo cấu hình
          </h3>
          <ul className="space-y-2 text-sm text-blue-800/80 font-medium">
            <li>• Phân bổ tổng tỉ lệ của 10 ô đúng bằng **100% (1.0)** để kết quả chuẩn xác nhất.</li>
            <li>• Bạn có thể gán cùng một Voucher cho nhiều ô khác nhau để tăng tỉ lệ trúng voucher đó.</li>
            <li>• Các ô không gán Voucher sẽ chỉ hiển thị nhãn (VD: "Chúc bạn may mắn lần sau").</li>
          </ul>
        </div>
        <div className="bg-red-50/50 border border-red-100 p-6 rounded-[24px]">
          <h3 className="font-black text-red-900 mb-2 flex items-center gap-2">
            ⚠️ Lưu ý Voucher
          </h3>
          <p className="text-sm text-red-800/80 font-medium leading-relaxed">
            Hệ thống chỉ liệt kê các Voucher có phân loại là **"Vòng quay"** hoặc được đánh dấu **"Hiện trên vòng quay"**. Đảm bảo Voucher vẫn còn số lượng và đang hoạt động.
          </p>
        </div>
      </div>

      {isPreviewOpen && (
        <LuckyWheel 
          isAdminPreview={true} 
          previewSlots={slots} 
          onPreviewClose={() => setIsPreviewOpen(false)} 
        />
      )}
    </div>
  );
};

export default AdminWheel;
